import React from 'react'
import { TextField, Typography } from '@mui/material'
import { com } from '@eidu/form'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import Field = com.eidu.sharedlib.entity.field.Field

export type EntityFormNumberInputProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
  updateField: (value: DraftFieldValue) => void
  error: boolean
}

const EntityFormNumberInput = ({ field, fieldValue, updateField, error }: EntityFormNumberInputProps) => (
  <>
    <TextField
      key={`field-${field.id.toString()}`}
      required={field.required}
      label={field.name}
      value={fieldValue?.value ?? ''}
      onChange={(event) => updateField({ fieldId: field.id, type: field.type, value: event.target.value })}
      error={error}
    />
    {fieldValue?.value && Number.isNaN(parseFloat(fieldValue.value)) && (
      <Typography>Please enter a valid number</Typography>
    )}
  </>
)

export default EntityFormNumberInput
